import module from './module'

export default module.name
